function offsetImg() {
    var $whatever = jQuery('.featured-video .img');
    if (jQuery($whatever).length > 0) {
        var offset = (jQuery(window).width() - ($whatever.offset().left + $whatever.outerWidth()));
        var right = parseInt(offset);
        jQuery('.featured-video .img-wrap').css('margin-right', -right);
    }
}

function offsetSinglePageCarousel() {
    var $openModalCarousel = jQuery('.open-modal-carousel'),
        screenWidth = jQuery(window).width();

    if (jQuery($openModalCarousel).length > 0) {
        console.log("W: ", screenWidth);
        var offset = screenWidth - (jQuery($openModalCarousel).offset().left + jQuery($openModalCarousel).width());
        console.log("Offset: ", offset);
        var right = parseInt(offset);
        jQuery($openModalCarousel).css('margin-right', -right);

    }
}

function offsetThePresident() {
    var $whatever = jQuery('.the-president');
    if (jQuery($whatever).length > 0) {
        var offset = (jQuery(window).width() - ($whatever.offset().left + $whatever.outerWidth()));
        var right = parseInt(offset);
        jQuery('.the-president-content').css('margin-right', -right);
    }
}


// Hamburger button
function openNavMobile() {
    var $hamburgerMenu = jQuery('#hamburger');

    jQuery($hamburgerMenu).unbind().click(function() {
        jQuery($hamburgerMenu).toggleClass('is-active');
    });
}

jQuery(window).on("resize", function() {
    openNavMobile();
    offsetThePresident();
    offsetSinglePageCarousel();
    offsetImg();
}).resize();;

jQuery(document).ready(function() {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

    // Adds Flex Video to YouTube and Vimeo Embeds
    jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
        if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
            jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
        } else {
            jQuery(this).wrap("<div class='responsive-embed'/>");
        }
    });

    // Before & Now - Load more
    var $loadBeforeAndNow = jQuery('.before-and-now-content .load-before-and-now');
    if (jQuery($loadBeforeAndNow).length > 0) {
        var perPage = $loadBeforeAndNow.data('per-page') * 2,
            cursor = perPage,
            items = jQuery('.before-and-now-content .items .item');

        jQuery($loadBeforeAndNow).on('click', function(e) {
            e.preventDefault();
            cursor = cursor + perPage;
            items.slice(0, cursor).removeClass('hide-mobile');

            console.log("Items1: ", items.size(), " Cursor1: ", cursor);

            if (items.size() <= cursor)
                jQuery($loadBeforeAndNow).addClass("no-more");

        });
    }

    // Partners - Load more
    var $loadPartnes = jQuery('.partners-two-column .load-partnes');
    if (jQuery($loadPartnes).length > 0) {
        var partnersPerPage = $loadPartnes.data('per-page'),
            partnersCursor = partnersPerPage,
            partnersItems = jQuery('.partners-two-column .items .item');

        jQuery($loadPartnes).on('click', function(e) {
            e.preventDefault();
            partnersCursor = partnersCursor + partnersPerPage;
            partnersItems.slice(0, partnersCursor).removeClass('hide-mobile');

            if (partnersItems.size() <= partnersCursor)
                jQuery($loadPartnes).addClass("no-more");

        });
    }


});